export const IS_CALENDAR_FILTER_SHOWN = 'IS_CALENDAR_FILTER_SHOWN'
export const CALENDAR_VALUE = 'CALENDAR_VALUE'
export const IS_ADD_TO_CALENDAR_MENU_SHOWN = 'IS_ADD_TO_CALENDAR_MENU_SHOWN'
export const CURRENT_EVENT_LINKS = 'CURRENT_EVENT_LINKS'